import { LightAsync as SyntaxHighlighter } from "react-syntax-highlighter";
import { lightfair } from "react-syntax-highlighter/dist/esm/styles/hljs";

export default function CodeBlock({ data }: { data: { snippet: string; language: string } }) {
  console.log(data.language);
  return (
    <div className="flex flex-col justify-center w-full p-4 ring-2 ring-gray-100 rounded-md">
      <SyntaxHighlighter className="block w-full" language={data.language} style={lightfair}>
        {data.snippet}
      </SyntaxHighlighter>
    </div>
  );
}
